// If you want these common features to appear client side ensure that in launch darkly the following checkbox is enabled
// Make this flag available to the client-side (JavaScript) SDK
export type Features =
    | 'brightcove-player'
    | 'ix-header-tag-wrapper'
    | 'email-author'
    | 'google-tag-manager'
    | 'gpt-ads'
    | 'nielsen-events'
    | 'track-js'
    | 'refresh-on-inactive'
    | 'can-autoplay-video'
    | 'can-autoplay-muted-video'
    | 'can-autoplay-next'
    | 'big-mobile-amp'
    | 'related-content'
    | 'snowplow'
    | 'prebid-video'
    | 'debug-ads'
    | 'newsletter-subscription-banner'
    | 'sticky-mrec'
    | 'standalone-amp-swm-player'
    | 'moat-adx-ad-tracking'
    | 'nielsen-video-events'
    | 'inline-card-video'
    | 'search'
    | 'canary'
    | 'world-collection'
    | 'use-oovvuu-recommendation'
    | 'cricketball'
    | 'digital-subscriptions'
    | 'bonzai-truskin'
    | 'outstream'
    | 'ad-tech-dfp-testing'
    | 'nielsen-video-events-inline-videos'
    | 'grapeshot'
    | 'mmo-bypass'
    | 'paywall-bypass-header'
    | 'ripple'
    | 'regionals'
    | 'immersive-story-article-template'
    | 'telethon-countdown'
    | 'running-parallax'
    | 'logo-takeover'
    | 'afl-draft'
    | 'simple-digital-subscription-form'
    | 'moat-yield-intelligence'
    | 'exclude-regional-topics-from-lists'
    | 'video-playlist'
    | 'cookie-consent'
    | 'community-news'
    | 'puzzles-target'
    | 'the-west-live'
    | 'the-west-live-catchup'
    | 'playlists-on-inline-videos'
    | 'native-lazy-loading'
    | 'force-west-live-activation'
    | 'video-series'
    | 'sport-breach-screen-variant'
    | 'taboola'
    | 'taboola-regionals'
    | 'companion-ads'
    | 'story-classification'
    | 'the-west-rewards'
    | 'registration-wall'
    | 'comments'
    | 'hero-image-as-video-poster'
    | 'native-chartbeat'
    | 'black-friday'
    | 'use-internal-content-api'
    | '50-off-breach-discount-govan50'
    | '50-off-breach-discount-coviddig'
    | 'adobe-audience-manager'
    | 'newsletter-subscriptions'
    | 'state-election-collection-topic-landing'
    | 'nielsen-subbrand'
    | 'app-upgrade-screen'
    | 'the-west-logo'
    | 'route-west-tonight'
    | '50-off-breach-discount'
    | 'south-west-curations'
    | 'sophi'
    | 'user-accounts'
    | 'perthnow-cng-redesign-teaser'
    | '7news-taboola-midarticle'
    | 'cng-to-perth-now-rebrand'
    | 'route-up-late'
    | 'jab-tracker'
    | 'jab-tracker'
    | 'puzzles'
    | 'digital-edition-redirects'
    | 'the-west-grand-final'
    | 'perthnow-grand-final'
    | 'the-west-grand-final-collection'
    | 'perthnow-grand-final-collection'
    | 'perthnow-grand-final-play-of-the-day'
    | 'live-ramp-ats'
    | '7ent-article-related'
    | '7ent-show-page-7plus-button'
    | '7news-contextual-link'
    | 'the-west-cnbc'
    | 'subscribe-with-google'
    | '7ent-article-7plus-button'
    | '7ent-article-layout'
    | '7ent-show-layout'
    | 'cricket-widgets'
    | 'queens-legacy-listing'
    | 'queens-legacy-home'
    | 'swg-breach-default'
    | 'swg-breach-albany-advertiser'
    | 'swg-breach-great-southern-herald'
    | 'swg-breach-augusta-margaret-river-times'
    | 'swg-breach-busselton-dunsborough-times'
    | 'swg-breach-broome-advertiser'
    | 'swg-breach-the-kimberley-echo'
    | 'swg-breach-geraldton-guardian'
    | 'swg-breach-midwest-times'
    | 'swg-breach-bunbury-herald'
    | 'swg-breach-harvey-waroona-reporter'
    | 'swg-breach-manjimup-bridgetown-times'
    | 'swg-breach-south-western-times'
    | 'swg-breach-kalgoorlie-miner'
    | 'swg-breach-narrogin-observer'
    | 'swg-breach-north-west-telegraph'
    | 'swg-breach-pilbara-news'
    | 'swg-breach-sound-telegraph'
    | 'swg-breach-countryman'
    | 'climate-change-home'
    | 'the-west-bar-regional'
    | 'taboola-bb-vip-show-page'
    | 'swg-entitlements-check'
    | 'perth-now-pride-logo'
    | '7-news-sport-curation-home-page-for-winters'
    | '7-news-winters-curation-home-page'
    | '7-news-winters-hamburger-menu'
    | '7-news-winters-contextual-link'
    | 'custom-sample-middleware'
    | 'feature-toggle-override'
    | '7-news-winters-header'
    | '7-news-winters-medal-tally-page'
    | '7-news-winters-schedule-page'
    | '7-news-winters-live-results-page'
    | 'subscriber-dropdown'
    | '7-lifestyle-full-page-layout'
    | 'subscriber-feature-tooltip'

export type TestFeatureState = { [K in Features]: boolean }

export const testFeatureState: TestFeatureState = {
    'world-collection': true,
    'brightcove-player': true,
    'ix-header-tag-wrapper': true,
    'email-author': true,
    'google-tag-manager': true,
    'gpt-ads': true,
    'nielsen-events': true,
    'track-js': true,
    'refresh-on-inactive': false,
    'can-autoplay-video': true,
    'can-autoplay-next': false,
    'can-autoplay-muted-video': false,
    'big-mobile-amp': false,
    'related-content': false,
    snowplow: true,
    'prebid-video': true,
    search: false,
    'debug-ads': false,
    'newsletter-subscription-banner': false,
    'sticky-mrec': false,
    'standalone-amp-swm-player': false,
    'moat-adx-ad-tracking': true,
    'nielsen-video-events': true,
    'inline-card-video': true,
    canary: false,
    'use-oovvuu-recommendation': false,
    cricketball: false,
    'digital-subscriptions': false,
    'bonzai-truskin': false,
    outstream: false,
    'ad-tech-dfp-testing': true,
    'nielsen-video-events-inline-videos': false,
    grapeshot: false,
    'mmo-bypass': false,
    'paywall-bypass-header': true,
    ripple: false,
    regionals: true,
    'immersive-story-article-template': false,
    'telethon-countdown': false,
    'running-parallax': false,
    'logo-takeover': false,
    'afl-draft': false,
    'simple-digital-subscription-form': false,
    'moat-yield-intelligence': false,
    'exclude-regional-topics-from-lists': false,
    'video-playlist': false,
    'cookie-consent': false,
    'community-news': true,
    'cng-to-perth-now-rebrand': true,
    'the-west-live': false,
    'playlists-on-inline-videos': false,
    'native-lazy-loading': false,
    'force-west-live-activation': false,
    'video-series': true,
    'sport-breach-screen-variant': true,
    taboola: true,
    'taboola-regionals': true,
    'companion-ads': false,
    'story-classification': true,
    'the-west-live-catchup': false,
    'the-west-rewards': true,
    'registration-wall': true,
    comments: false,
    'hero-image-as-video-poster': true,
    'native-chartbeat': true,
    'black-friday': false,
    'use-internal-content-api': true,
    '50-off-breach-discount-govan50': false,
    '50-off-breach-discount-coviddig': false,
    'adobe-audience-manager': false,
    'newsletter-subscriptions': true,
    'state-election-collection-topic-landing': false,
    'nielsen-subbrand': true,
    'app-upgrade-screen': true,
    'the-west-logo': true,
    'route-west-tonight': true,
    '50-off-breach-discount': false,
    'south-west-curations': false,
    sophi: false,
    'user-accounts': false,
    'perthnow-cng-redesign-teaser': false,
    '7news-taboola-midarticle': true,
    'route-up-late': true,
    'jab-tracker': true,
    'puzzles-target': false,
    puzzles: true,
    'digital-edition-redirects': true,
    'the-west-grand-final': true,
    'perthnow-grand-final': true,
    'the-west-grand-final-collection': true,
    'perthnow-grand-final-collection': true,
    'perthnow-grand-final-play-of-the-day': true,
    'live-ramp-ats': true,
    '7ent-article-related': true,
    '7ent-show-page-7plus-button': true,
    '7news-contextual-link': true,
    'the-west-cnbc': true,
    'subscribe-with-google': false,
    '7ent-article-7plus-button': true,
    '7ent-article-layout': true,
    '7ent-show-layout': true,
    'cricket-widgets': true,
    'queens-legacy-listing': false,
    'queens-legacy-home': false,
    'swg-breach-default': false,
    'swg-breach-albany-advertiser': false,
    'swg-breach-great-southern-herald': false,
    'swg-breach-augusta-margaret-river-times': false,
    'swg-breach-busselton-dunsborough-times': false,
    'swg-breach-broome-advertiser': false,
    'swg-breach-the-kimberley-echo': false,
    'swg-breach-geraldton-guardian': false,
    'swg-breach-midwest-times': false,
    'swg-breach-bunbury-herald': false,
    'swg-breach-harvey-waroona-reporter': false,
    'swg-breach-manjimup-bridgetown-times': false,
    'swg-breach-south-western-times': false,
    'swg-breach-kalgoorlie-miner': false,
    'swg-breach-narrogin-observer': false,
    'swg-breach-north-west-telegraph': false,
    'swg-breach-pilbara-news': false,
    'swg-breach-sound-telegraph': false,
    'swg-breach-countryman': false,
    'climate-change-home': false,
    'the-west-bar-regional': true,
    'taboola-bb-vip-show-page': true,
    'swg-entitlements-check': false,
    'perth-now-pride-logo': false,
    '7-news-winters-header': true,
    '7-news-winters-hamburger-menu': false,
    '7-news-winters-curation-home-page': false,
    '7-news-sport-curation-home-page-for-winters': false,
    '7-news-winters-contextual-link': true,
    'custom-sample-middleware': false,
    'feature-toggle-override': true,
    '7-news-winters-medal-tally-page': true,
    '7-news-winters-schedule-page': true,
    '7-news-winters-live-results-page': true,
    'subscriber-dropdown': true,
    '7-lifestyle-full-page-layout': true,
    'subscriber-feature-tooltip': true,
}
